exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__photo___2nv8A{max-width:180px;max-height:180px}.style__img___AhICd{width:180px;height:180px;background-size:contain}.style__externalImg___3DtWB.style__jewelry___2DU8F{background-image:url(" + require("./img/jewelry-placeholder-external@2x.png") + ")}.style__noImg___2JR5y.style__jewelry___2DU8F{background-image:url(" + require("./img/jewelry-placeholder@2x.png") + ")}.style__noImg___2JR5y.style__jewelry___2DU8F.style__summary___3sGE7{background-image:url(" + require("./img/summary-jewelry-placeholder@2x.png") + ")}.style__externalImg___3DtWB.style__jewelry___2DU8F.style__summary___3sGE7{background-image:url(" + require("./img/summary-jewelry-placeholder-external@2x.png") + ")}", ""]);

// exports
exports.locals = {
	"photo": "style__photo___2nv8A",
	"img": "style__img___AhICd",
	"noImg": "style__noImg___2JR5y style__img___AhICd",
	"externalImg": "style__externalImg___3DtWB",
	"jewelry": "style__jewelry___2DU8F",
	"summary": "style__summary___3sGE7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/jewelry-photo/style.css
// module id = 684
// module chunks = 0